import classnames from 'classnames/bind'
import { useRouter } from 'next/router'
import { useTranslation } from 'next-i18next'

// Components
import { ArrowRightIcon, ChatIcon } from '../Icons'

// Libs
import localizePath from '@/methods/url/localizePath'

// Constants
import { EXTERNAL_LINK } from '@/constants/externalLink'
import { REGION } from '@/constants/region'

// Styles
import styles from '../../style.module.scss'

const cx = classnames.bind(styles)

/** 頁尾「還是找不到答案？」：客服入口與 header / footer 的「客服中心」一致（台灣 LINE，其他站另一個入口） */
const ContactCta = ({ countryCode }: { countryCode: string }) => {
  const { t } = useTranslation()
  const { locale } = useRouter()
  const url = localizePath(countryCode === REGION.TW ? EXTERNAL_LINK.CUSTOMER_SERVICE_CENTER : EXTERNAL_LINK.CUSTOMER_SERVICE_CENTER_HK, locale)

  return (
    <section className={cx('help-contact')}>
      <span className={cx('help-contact__icon')}>
        <ChatIcon />
      </span>
      <div className={cx('help-contact__text')}>
        <p className={cx('help-contact__title')}>{t('Help_Center_Contact_Title')}</p>
        <p className={cx('help-contact__desc')}>{t('Help_Center_Contact_Desc')}</p>
      </div>
      <a className={cx('help-contact__button')} href={url} target={url.startsWith('http') ? '_blank' : undefined} rel='noopener noreferrer'>
        {t('Help_Center_Contact_Button')}
        <ArrowRightIcon size={16} />
      </a>
    </section>
  )
}

export default ContactCta
